import { Minnesota } from "./statesAbbreviations";

const dscrLoanStateData = {
  "New Jersey": {
    image1: "uploads/nj_Image_bqxzm7bqxzm7bqxz_9eb43a8a1f.jpeg",
    image2: "uploads/nj_Image_lbm59klbm59klbm5_7ce2d7883f.jpeg",
    whyUsList: [
      "fastClose",
      "onlineProcessing",
      "experiencedInvestorsChooseUs",
    ],
    dscrCalculation: {
      "Credit score": 700,
      "Purchase price": 285000, // Reduced by 15% from 335000
      "Monthly rent": 3080, // Increased by 10% from 2800
      "Annual taxes": 855, // 0.3% of purchase price
      "Annual insurance": 1350,
      "Annual HOA": 250,
      "Loan to value (LTV)": 75,
      "Loan amount": 213750,
      "Interest rate": 6.37,
      "Title fees": 1200,
      "Prepaid interest": 350,
      "Prepaid insurance": 550,
      "Loan purpose": "Purchase",
    },
  },
  California: {
    image1: "uploads/DSCR_Loan_California_Cover_Photo_cb716bf25a.jpg",
    image2: "uploads/streetview_e4fe5e7c60.jpeg",
    whyUsList: ["dedicatedClosingTeam", "googleReviews", "stateExperience"],
    dscrCalculation: {
      "Credit score": 720,
      "Purchase price": 425000, // Reduced by 15% from 500000
      "Monthly rent": 4400, // Increased by 10% from 4000
      "Annual taxes": 1275, // 0.3% of purchase price
      "Annual insurance": 1800,
      "Annual HOA": 400,
      "Loan to value (LTV)": 75,
      "Loan amount": 318750,
      "Interest rate": 6.37,
      "Title fees": 1600,
      "Prepaid interest": 525,
      "Prepaid insurance": 750,
      "Loan purpose": "Purchase",
    },
  },
  // OLD ONES
  Texas: {
    image1: "uploads/DSCR_Loan_Texas_Cover_Photo_30752c6d77.jpg",
    image2: "uploads/texas_Image_a36y8ya36y8ya36y_ed216c66e3.jpeg",
    whyUsList: [
      "fastClose",
      "onlineProcessing",
      "experiencedInvestorsChooseUs",
    ],
    dscrCalculation: {
      "Credit score": 710,
      "Purchase price": 295000, // Reduced by 15% from 347000
      "Monthly rent": 3080, // Increased by 10% from 2800
      "Annual taxes": 885, // 0.3% of purchase price
      "Annual insurance": 1350,
      "Annual HOA": 250,
      "Loan to value (LTV)": 75,
      "Loan amount": 221250,
      "Interest rate": 6.37,
      "Title fees": 1200,
      "Prepaid interest": 375,
      "Prepaid insurance": 550,
      "Loan purpose": "Purchase",
    },
  },
  Arizona: {
    image1: "uploads/DSCR_Loan_Arizona_Cover_Photo_cfec9211e1.jpg",
    image2: "uploads/Screenshot_20240319_154844_Lead_Connector_c96551440e.jpg",
    whyUsList: ["fastClose", "googleReviews", "experiencedInvestorsChooseUs"],
    dscrCalculation: {
      "Credit score": 695,
      "Purchase price": 229500, // Reduced by 15% from 270000
      "Monthly rent": 2420, // Increased by 10% from 2200
      "Annual taxes": 689, // 0.3% of purchase price
      "Annual insurance": 900,
      "Annual HOA": 110,
      "Loan to value (LTV)": 75,
      "Loan amount": 172125, // 75% of new purchase price
      "Interest rate": 6.5,
      "Loan purpose": "Purchase",
    },
  },
  Michigan: {
    image1: "uploads/DSCR_Loan_Michigan_Cover_Photo_b04611a5b1.jpg",
    image2: "uploads/blob_84c9c085e1",
    whyUsList: ["dedicatedClosingTeam", "googleReviews", "stateExperience"],
    dscrCalculation: {
      "Credit score": 681,
      "Purchase price": 187000, // Reduced by 15% from 220000
      "Monthly rent": 1210, // Increased by 10% from 1100
      "Annual taxes": 561, // 0.3% of purchase price
      "Annual insurance": 900,
      "Annual HOA": 101,
      "Loan to value (LTV)": 75,
      "Loan amount": 140250, // 75% of new purchase price
      "Interest rate": 6.5,
      "Loan purpose": "Purchase",
    },
  },
  Minnesota: {
    image1: "uploads/220127_Minneapolis_Saint_Paul_9420b4864f.jpg",
    image2: "uploads/IMG_5459_49d30eb5d3.jpg",
    whyUsList: ["fastClose", "dedicatedClosingTeam", "onlineProcessing"],
    dscrCalculation: {
      "Credit score": 689,
      "Purchase price": 127500, // Reduced by 15% from 150000
      "Monthly rent": 2090, // Increased by 10% from 1900
      "Annual taxes": 383, // 0.3% of purchase price
      "Annual insurance": 510,
      "Annual HOA": 10,
      "Loan to value (LTV)": 75,
      "Loan amount": 95625, // 75% of new purchase price
      "Interest rate": 6.5,
      "Loan purpose": "Purchase",
    },
  },
  Nebraska: {
    image1: "uploads/DSCR_loan_Omaha_Nebraska_152109ccf9.jpg",
    image2: "uploads/small_IMG_1100_d298e5bb8c_3def1ada1e.jpg",
    whyUsList: ["appraisalControl", "lowFees", "bestRate"],
    dscrCalculation: {
      "Credit score": 700,
      "Purchase price": 161500, // Reduced by 15% from 190000
      "Monthly rent": 3299, // Increased by 10% from 2999
      "Annual taxes": 485, // 0.3% of purchase price
      "Annual insurance": 1999,
      "Annual HOA": 89,
      "Loan to value (LTV)": 75,
      "Loan amount": 121125, // 75% of new purchase price
      "Interest rate": 6.5,
      "Loan purpose": "Purchase",
    },
  },
  "New York": {
    image1: "uploads/DSCR_Loan_New_York_Cover_Photo_14b4baa9a1.jpg",
    image2: "uploads/7_0661cece0f.jpg",
    whyUsList: [
      "fastClose",
      "onlineProcessing",
      "experiencedInvestorsChooseUs",
    ],
    dscrCalculation: {
      "Credit score": 689,
      "Purchase price": 95200, // Reduced by 15% from 112000
      "Monthly rent": 2528, // Increased by 10% from 2298
      "Annual taxes": 286, // 0.3% of purchase price
      "Annual insurance": 2004,
      "Annual HOA": 11,
      "Loan to value (LTV)": 75,
      "Loan amount": 71400,
      "Interest rate": 6.37,
      "Title fees": 700, // Based on lower purchase price
      "Prepaid interest": 150,
      "Prepaid insurance": 300,
      "Loan purpose": "Purchase",
    },
  },
  Maryland: {
    image1: "uploads/DSCR_Loan_Maryland_Cover_Photo_1c3beeccea.jpg",
    image2: "uploads/streetview_53d08f7e28.jpeg",
    whyUsList: ["dedicatedClosingTeam", "googleReviews", "stateExperience"],
    dscrCalculation: {
      "Credit score": 705,
      "Purchase price": 255000, // Reduced by 15% from 299999
      "Monthly rent": 2580, // Increased by 10% from 2345
      "Annual taxes": 765, // 0.3% of purchase price
      "Annual insurance": 789,
      "Annual HOA": 12,
      "Loan to value (LTV)": 75,
      "Loan amount": 191250,
      "Interest rate": 6.37,
      "Title fees": 900,
      "Prepaid interest": 250,
      "Prepaid insurance": 400,
      "Loan purpose": "Purchase",
    },
  },
  Kansas: {
    image1: "uploads/Wichita_Kansas_DSCR_Loan_c6dceba056.jpg",
    image2: "uploads/1000002928_aaf1249a1b_8751ddf1b9.jpg",
    whyUsList: ["appraisalControl", "lowFees", "bestRate"],
    dscrCalculation: {
      "Credit score": 719, // 680-720
      "Purchase price": 230000, // 110k-300k
      "Monthly rent": 2700, // 1k-3k
      "Annual taxes": 1890, // 1k-3k
      "Annual insurance": 780, // 500-3k
      "Annual HOA": 107, // 0 - 500
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 172500, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Indiana: {
    image1: "uploads/DSCR_Loan_Indiana_Cover_Photo_40a316e42d.jpg",
    image2: "uploads/small_Outside_Back_1_d26d98e696_190a16f9fb.jpg",
    whyUsList: [
      "fastClose",
      "onlineProcessing",
      "experiencedInvestorsChooseUs",
    ],
    dscrCalculation: {
      "Credit score": 699, // 680-720
      "Purchase price": 289999, // 110k-300k
      "Monthly rent": 2349, // 1k-3k
      "Annual taxes": 2222, // 1k-3k
      "Annual insurance": 666, // 500-3k
      "Annual HOA": 111, // 0 - 500
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 217499, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Georgia: {
    image1: "uploads/Image_rbgl6urbgl6urbgl_c8515ae50f.jpeg",
    image2: "uploads/Screenshot_2025_04_15_at_4_21_32_AM_78d7d98c1b.png",
    whyUsList: ["dedicatedClosingTeam", "googleReviews", "stateExperience"],
    dscrCalculation: {
      "Credit score": 705,
      "Purchase price": 275000, // Reduced by 15% from 323500
      "Monthly rent": 2860, // Increased by 10% from 2600
      "Annual taxes": 825, // 0.3% of purchase price
      "Annual insurance": 1300,
      "Annual HOA": 225,
      "Loan to value (LTV)": 75,
      "Loan amount": 206250,
      "Interest rate": 6.37,
      "Title fees": 1150,
      "Prepaid interest": 325,
      "Prepaid insurance": 525,
      "Loan purpose": "Purchase",
    },
  },
  Florida: {
    image1: "uploads/DSCR_Loan_Florida_Cover_Photo_2513f44446.jpg",
    image2: "uploads/streetview_d328fdd881.jfif",
    whyUsList: [
      "fastClose",
      "onlineProcessing",
      "experiencedInvestorsChooseUs",
    ],
    dscrCalculation: {
      "Credit score": 715,
      "Purchase price": 255000, // Reduced by 15% from 370000
      "Monthly rent": 3300, // Increased by 10% from 3000
      "Annual taxes": 945, // 0.3% of purchase price
      "Annual insurance": 1450,
      "Annual HOA": 300,
      "Loan to value (LTV)": 75,
      "Loan amount": 191250,
      "Interest rate": 6.37,
      "Title fees": 1300,
      "Prepaid interest": 400,
      "Prepaid insurance": 600,
      "Loan purpose": "Purchase",
    },
  },
  Virginia: {
    image1: "uploads/images_aad134ef3b.jpg",
    image2:
      "uploads/small_Screenshot_2024_09_06_at_10_35_45_PM_b17b4c7874_b0afb9fc31.jpg",
    whyUsList: [
      "fastClose",
      "onlineProcessing",
      "experiencedInvestorsChooseUs",
    ],
    dscrCalculation: {
      "Credit score": 696, // 680-720
      "Purchase price": 240000, // 110k-300k
      "Monthly rent": 2400, // 1k-3k
      "Annual taxes": 1400, // 1k-3k
      "Annual insurance": 740, // 500-3k
      "Annual HOA": 140, // 0 - 500
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 180000, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Utah: {
    image1: "uploads/utah_landscape_winter_613d97d954_2_2e698b9739.jpg",
    image2: "uploads/download_2_436bcb0f21.jpg",
    whyUsList: ["dedicatedClosingTeam", "googleReviews", "stateExperience"],
    dscrCalculation: {
      "Credit score": 683, // 680-720
      "Purchase price": 230000, // 110k-300k
      "Monthly rent": 2300, // 1k-3k
      "Annual taxes": 1300, // 1k-3k
      "Annual insurance": 703, // 500-3k
      "Annual HOA": 103, // 0 - 500
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 172500, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  "South Carolina": {
    image1: "uploads/DSCR_Loan_South_Carolina_Cover_Photo_bd4401845c.jpg",
    image2: "uploads/download_6_efa87a4dc3.jpg",
    whyUsList: ["appraisalControl", "lowFees", "bestRate"],
    dscrCalculation: {
      "Credit score": 686, // 680-720
      "Purchase price": 290600, // 110k-300k
      "Monthly rent": 2060, // 1k-3k
      "Annual taxes": 1806, // 1k-3k
      "Annual insurance": 760, // 500-3k
      "Annual HOA": 106, // 0 - 500
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 218450, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Ohio: {
    image1: "uploads/DSCR_Loan_Ohio_Cover_Photo_b621666b69.jpg",
    image2: "uploads/75fc0716c77c9fd0795d8758cdc404a4_cc_ft_768_6c89914365.jpg",
    whyUsList: [
      "fastClose",
      "onlineProcessing",
      "experiencedInvestorsChooseUs",
    ],
    dscrCalculation: {
      "Credit score": 688, // 680-720
      "Purchase price": 290800, // 110k-300k
      "Monthly rent": 2080, // 1k-3k
      "Annual taxes": 1880, // 1k-3k
      "Annual insurance": 708, // 500-3k
      "Annual HOA": 480, // 0 - 500
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 218100, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Alaska: {
    image1: "uploads/download_7_703ceb1e73.jpg",
    image2: "uploads/alaska_2a7d037b27.jpg",
    whyUsList: ["dedicatedClosingTeam", "googleReviews", "stateExperience"],
    dscrCalculation: {
      "Credit score": 699, // 680-720
      "Purchase price": 199969, // 110k-300k
      "Monthly rent": 2190, // 1k-3k
      "Annual taxes": 1150, // 1k-3k
      "Annual insurance": 1200, // 500-3k
      "Annual HOA": 53, // 0 - 500
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 149976, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  "South Dakota": {
    image1: "uploads/South_Dakota_8bd2574334.jpg",
    image2: "uploads/South_Dakota_9e3c21bd13.jpg",
    whyUsList: ["appraisalControl", "lowFees", "bestRate"],
    dscrCalculation: {
      "Credit score": 719, // 680-720
      "Purchase price": 290050, // 110k-300k
      "Monthly rent": 2900, // 1k-3k
      "Annual taxes": 2890, // 1k-3k
      "Annual insurance": 2897, // 500-3k
      "Annual HOA": 467, // 0 - 500
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 217538, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  "North Carolina": {
    image1: "uploads/DSCR_Loan_North_Carolina_Cover_Photo_b2a55ed3ae.jpg",
    image2: "uploads/North_Carolina_USA_8a5af61e99.jpg",
    whyUsList: [
      "fastClose",
      "onlineProcessing",
      "experiencedInvestorsChooseUs",
    ],
    dscrCalculation: {
      "Credit score": 716, // 680-720
      "Purchase price": 290700, // 110k-300k
      "Monthly rent": 2006, // 1k-3k
      "Annual taxes": 1808, // 1k-3k
      "Annual insurance": 709, // 500-3k
      "Annual HOA": 107, // 0 - 500
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 218025, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Nevada: {
    image1: "uploads/Nevada_USA_0ed03c2e2c.jpg",
    image2: "uploads/Nevada_daefea680f.jpg",
    whyUsList: ["dedicatedClosingTeam", "googleReviews", "stateExperience"],
    dscrCalculation: {
      "Credit score": 685, // 680-720
      "Purchase price": 290088, // 110k-300k
      "Monthly rent": 2050, // 1k-3k
      "Annual taxes": 1850, // 1k-3k
      "Annual insurance": 770, // 500-3k
      "Annual HOA": 410, // 0 - 500
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 217566, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Vermont: {
    image1: "uploads/Vermont_72d1199a57.jpg",
    image2:
      "uploads/small_26_CB_0_FCB_B3_BD_4_FEC_AAAC_0_DF_5_DA_6_D7099_3074296277_eb31ad023c.jpg",
    whyUsList: ["appraisalControl", "lowFees", "bestRate"],
    dscrCalculation: {
      "Credit score": 683, // 680-720
      "Purchase price": 290003, // 110k-300k
      "Monthly rent": 2030, // 1k-3k
      "Annual taxes": 1300, // 1k-3k
      "Annual insurance": 703, // 500-3k
      "Annual HOA": 130, // 0 - 500
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 217502, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Colorado: {
    image1: "uploads/mana5280_IWG_Mt_P_Ubm8_Q_unsplash_min_d5faeec441.jpg",
    image2: "uploads/02_DSC_1260_min_min_12e8bb4abb.jpg",
    whyUsList: ["googleReviews", "bestRate", "dedicatedClosingTeam"],
    dscrCalculation: {
      "Credit score": 687,
      "Purchase price": 670000,
      "Monthly rent": 4400,
      "Annual taxes": 3400,
      "Annual insurance": 3000,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 502500, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Connecticut: {
    image1: "uploads/Untitled_min_1_fd5703f321.jpg",
    image2: "uploads/Screenshot_2024_04_23_at_12_40_51_AM_min_a918218454.png",
    whyUsList: ["appraisalControl", "stateExperience", "lowFees"],
    dscrCalculation: {
      "Credit score": 684,
      "Purchase price": 370000,
      "Monthly rent": 2600,
      "Annual taxes": 3000,
      "Annual insurance": 1700,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 277500, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Mississippi: {
    image1: "uploads/justin_wilkens_Fajyl_TZ_2_YGI_unsplash_min_32d1d3d3ff.jpg",
    image2: "uploads/Screenshot_2024_04_25_at_11_34_01_PM_min_72dc0d9f50.png",
    whyUsList: ["lowFees", "dedicatedClosingTeam", "stateExperience"],
    dscrCalculation: {
      "Credit score": 680,
      "Purchase price": 255000,
      "Monthly rent": 2125,
      "Annual taxes": 1900,
      "Annual insurance": 1350,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 191250, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Missouri: {
    image1: "uploads/mike_gattorna_k_SLE_94v8_AIY_unsplash_min_c1f6f0dd6f.jpg",
    image2: "uploads/Screenshot_2024_05_06_at_8_59_06_PM_min_9e526fae31.png",
    whyUsList: [
      "googleReviews",
      "experiencedInvestorsChooseUs",
      "dedicatedClosingTeam",
    ],
    dscrCalculation: {
      "Credit score": 680,
      "Purchase price": 260000,
      "Monthly rent": 2025,
      "Annual taxes": 1900,
      "Annual insurance": 1600,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 195000, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Montana: {
    image1: "uploads/john_kakuk_O_Ym7afxef8o_unsplash_min_0b9e0f2f37.jpg",
    image2: "uploads/527_Circle_Dr_min_c100c7d202.jpg",
    whyUsList: ["lowFees", "bestRate", "stateExperience"],
    dscrCalculation: {
      "Credit score": 691,
      "Purchase price": 120000,
      "Monthly rent": 1050,
      "Annual taxes": 700,
      "Annual insurance": 600,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 90000, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  "New Hampshire": {
    image1: "uploads/nh_min_f3b12b3c2c.jpg",
    image2: "uploads/nh_2_fc1cf2f1bc.jpg",
    whyUsList: ["stateExperience", "appraisalControl", "lowFees"],
    dscrCalculation: {
      "Credit score": 692,
      "Purchase price": 127000,
      "Monthly rent": 1350,
      "Annual taxes": 900,
      "Annual insurance": 1200,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 95250, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  "New Mexico": {
    image1:
      "uploads/andreas_rasmussen_Nrxnff_JMYI_8_unsplash_min_379022cf35.jpg",
    image2: "uploads/IMG_4697_min_9ed32621c7.jpeg",
    whyUsList: ["bestRate", "googleReviews", "stateExperience"],
    dscrCalculation: {
      "Credit score": 680,
      "Purchase price": 160000,
      "Monthly rent": 1300,
      "Annual taxes": 900,
      "Annual insurance": 900,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 120000, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  "North Dakota": {
    image1: "uploads/rich_martello_e_P_Ax4p20_T_Uw_unsplash_min_eb758654a3.jpg",
    image2: "uploads/Untitled_341_min_99440cc5e3.jpg",
    whyUsList: ["stateExperience", "fastClose", "lowFees"],
    dscrCalculation: {
      "Credit score": 681,
      "Purchase price": 410000,
      "Monthly rent": 2900,
      "Annual taxes": 2800,
      "Annual insurance": 2100,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 307500, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Massachusetts: {
    image1: "uploads/cdma_ww_F1_U_Euud_H8_unsplash_min_e0d1a7af6e.jpg",
    image2: "uploads/Untitled_423_min_a6f4af0a36.jpg",
    whyUsList: ["stateExperience", "googleReviews", "onlineProcessing"],
    dscrCalculation: {
      "Credit score": 680,
      "Purchase price": 140000,
      "Monthly rent": 1525,
      "Annual taxes": 1000,
      "Annual insurance": 900,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 105000, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Maine: {
    image1:
      "uploads/savannah_rohleder_rh_It_UAQ_Pw_Hk_unsplash_min_083407b8ee.jpg",
    image2: "uploads/12331_min_e22baae604.jpg",
    whyUsList: ["dedicatedClosingTeam", "stateExperience", "googleReviews"],
    dscrCalculation: {
      "Credit score": 680,
      "Purchase price": 180000,
      "Monthly rent": 1500,
      "Annual taxes": 700,
      "Annual insurance": 600,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 135000, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Louisiana: {
    image1: "uploads/jp_valery_O0l_Mg_O8f5w0_unsplash_min_560758c8b8.jpg",
    image2: "uploads/Screenshot_2024_05_07_at_12_48_09_AM_min_7dcda0adb2.png",
    whyUsList: ["lowFees", "appraisalControl", "bestRate"],
    dscrCalculation: {
      "Credit score": 683,
      "Purchase price": 540000,
      "Monthly rent": 3800,
      "Annual taxes": 4200,
      "Annual insurance": 3000,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 405000, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Kentucky: {
    image1: "uploads/tolga_ahmetler_5j_Jix_Re_Bwxw_unsplash_min_b150193a3f.jpg",
    image2: "uploads/Screenshot_2024_04_30_113649_min_7cf38e5903.png",
    whyUsList: ["stateExperience", "googleReviews", "fastClose"],
    dscrCalculation: {
      "Credit score": 683,
      "Purchase price": 135000,
      "Monthly rent": 1300,
      "Annual taxes": 1200,
      "Annual insurance": 500,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 101250, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Iowa: {
    image1: "uploads/austin_goode_5pg_Jv_Of_Lew_unsplash_min_fc5ffd7747.jpg",
    image2: "uploads/IMG_20230228_114121_806_622055ab07_min_11b9b4f059.jpeg",
    whyUsList: ["stateExperience", "googleReviews", "lowFees"],
    dscrCalculation: {
      "Credit score": 685,
      "Purchase price": 125000,
      "Monthly rent": 1300,
      "Annual taxes": 900,
      "Annual insurance": 500,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 93750, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Illinois: {
    image1: "uploads/DSCR_Loan_Illinois_Cover_Photo_d327c8fcb1.jpg",
    image2: "uploads/GA_Image_iok899iok899iok8_2aabfd7f8e.jpeg",
    whyUsList: ["dedicatedClosingTeam", "googleReviews", "stateExperience"],
    dscrCalculation: {
      "Credit score": 695,
      "Purchase price": 255000, // Reduced by 15% from 300000
      "Monthly rent": 2750, // Increased by 10% from 2500
      "Annual taxes": 765, // 0.3% of purchase price
      "Annual insurance": 1250,
      "Annual HOA": 200,
      "Loan to value (LTV)": 75,
      "Loan amount": 191250,
      "Interest rate": 6.37,
      "Title fees": 1100,
      "Prepaid interest": 300,
      "Prepaid insurance": 500,
      "Loan purpose": "Purchase",
    },
  },
  Idaho: {
    image1: "uploads/abigail_loney_Sx_Nk_s_Pk_RQE_unsplash_min_ab371dd56b.jpg",
    image2: "uploads/231234_min_0fea6c1110.jpg",
    whyUsList: ["onlineProcessing", "lowFees", "stateExperience"],
    dscrCalculation: {
      "Credit score": 682,
      "Purchase price": 135000,
      "Monthly rent": 1200,
      "Annual taxes": 800,
      "Annual insurance": 500,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 101250, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Hawaii: {
    image1: "uploads/dustin_belt_xfw_Fn5_LHA_8w_unsplash_min_60deb234ff.jpg",
    image2: "uploads/3714_GARAGE_2_min_5230493c02.png",
    whyUsList: ["stateExperience", "bestRate", "lowFees"],
    dscrCalculation: {
      "Credit score": 680,
      "Purchase price": 320000,
      "Monthly rent": 2400,
      "Annual taxes": 1700,
      "Annual insurance": 900,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 240000, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Delaware: {
    image1: "uploads/Untitled_1232_min_3e31ee4a95.jpg",
    image2: "uploads/Screenshot_2024_04_23_at_12_30_20_AM_min_f885d5d62b.png",
    whyUsList: ["googleReviews", "stateExperience", "bestRate"],
    dscrCalculation: {
      "Credit score": 681,
      "Purchase price": 130000,
      "Monthly rent": 925,
      "Annual taxes": 1100,
      "Annual insurance": 850,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 97500, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Wyoming: {
    image1: "uploads/1231455_min_041f1f6c46.jpg",
    image2: "uploads/Untitled_524_min_879421fd45.jpg",
    whyUsList: ["stateExperience", "fastClose", "bestRate"],
    dscrCalculation: {
      "Credit score": 685,
      "Purchase price": 165000,
      "Monthly rent": 1400,
      "Annual taxes": 900,
      "Annual insurance": 700,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 123750, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Wisconsin: {
    image1: "uploads/mandie_barber_y_x76k_Q8g9o_unsplash_min_f45c4125f5.jpg",
    image2: "uploads/Untitled_21_min_1867bcecab.jpg",
    whyUsList: ["fastClose", "onlineProcessing", "dedicatedClosingTeam"],
    dscrCalculation: {
      "Credit score": 686,
      "Purchase price": 158000,
      "Monthly rent": 1350,
      "Annual taxes": 1200,
      "Annual insurance": 700,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 118500, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  "West Virginia": {
    image1:
      "uploads/sharosh_rajasekher_wdzm_E_Eob_Y8_U_unsplash_min_67f31e3ede.jpg",
    image2: "uploads/IMG_7599_min_e8da66704e.JPG",
    whyUsList: ["appraisalControl", "lowFees", "stateExperience"],
    dscrCalculation: {
      "Credit score": 689,
      "Purchase price": 235000,
      "Monthly rent": 1900,
      "Annual taxes": 1600,
      "Annual insurance": 950,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 176250, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  "Washington DC": {
    image1: "uploads/yeon_choi_7j_WQJ_t_U_Um_I_unsplash_fa77a5fc3c.jpg",
    image2: "uploads/IMG_8240_min_1ea3ba3b83.jpg",
    whyUsList: ["bestRate", "lowFees", "onlineProcessing"],
    dscrCalculation: {
      "Credit score": 683,
      "Purchase price": 465000,
      "Monthly rent": 3600,
      "Annual taxes": 4200,
      "Annual insurance": 2330,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 348750, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Washington: {
    image1: "uploads/dave_hoefler_x_Zd_L_Uzuxn_VY_unsplash_min_8367fcd693.jpg",
    image2: "uploads/A1_min_d63612cd12.jpeg",
    whyUsList: ["stateExperience", "dedicatedClosingTeam", "fastClose"],
    dscrCalculation: {
      "Credit score": 683,
      "Purchase price": 484500, // Reduced by 15% from 570000
      "Monthly rent": 4675, // Increased by 10% from 4250
      "Annual taxes": 1454, // 0.3% of purchase price
      "Annual insurance": 3700,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75,
      "Loan amount": 363375, // 75% of new purchase price
      "Interest rate": 6.37,
      "Loan purpose": "Purchase",
    },
  },
  Tennessee: {
    image1: "uploads/simon_ray_7j_Mi_KXL_574k_unsplash_min_55effe0b43.jpg",
    image2: "uploads/Untitled_min_06147b74e6.jpg",
    whyUsList: ["stateExperience", "bestRate", "googleReviews"],
    dscrCalculation: {
      "Credit score": 683,
      "Purchase price": 140000,
      "Monthly rent": 1300,
      "Annual taxes": 900,
      "Annual insurance": 700,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 105000, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  "Rhode Island": {
    image1:
      "uploads/michael_denning_g_Pj_U_Se_XOCE_unsplash_min_df0e5a737e.jpg",
    image2: "uploads/Screenshot_2024_04_18_at_9_14_40_PM_min_2d781ed579.png",
    whyUsList: ["onlineProcessing", "stateExperience", "lowFees"],
    dscrCalculation: {
      "Credit score": 684,
      "Purchase price": 170000,
      "Monthly rent": 1500,
      "Annual taxes": 1100,
      "Annual insurance": 900,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 127500, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Pennsylvania: {
    image1: "uploads/kirk_thornton_p_Jomg_YEOM_04_unsplash_min_b316f9c2a2.jpg",
    image2: "uploads/Screenshot_2024_04_30_at_2_05_19_AM_min_f1eb152924.png",
    whyUsList: ["appraisalControl", "stateExperience", "fastClose"],
    dscrCalculation: {
      "Credit score": 682,
      "Purchase price": 335000,
      "Monthly rent": 2800,
      "Annual taxes": 2100,
      "Annual insurance": 2000,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 251250, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Oregon: {
    image1: "uploads/zachary_keimig_S_Kk_Y2_E636qo_unsplash_min_b32c8ed8a0.jpg",
    image2: "uploads/oregon_t_min_79c97e300f.jpg",
    whyUsList: ["stateExperience", "lowFees", "onlineProcessing"],
    dscrCalculation: {
      "Credit score": 680,
      "Purchase price": 110000,
      "Monthly rent": 1225,
      "Annual taxes": 1100,
      "Annual insurance": 600,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 82500, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Oklahoma: {
    image1: "uploads/raychel_sanner_MB_Jzd1_VNC_0_unsplash_min_2de8779fcb.jpg",
    image2: "uploads/Smart_Select_20240324_211441_Zillow_min_3b079eb4a3.jpg",
    whyUsList: ["stateExperience", "appraisalControl", "googleReviews"],
    dscrCalculation: {
      "Credit score": 681,
      "Purchase price": 154000,
      "Monthly rent": 1425,
      "Annual taxes": 900,
      "Annual insurance": 800,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 115500, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Arkansas: {
    image1:
      "uploads/brandon_johnson_ws_ESL_4_N_Ekd_M_unsplash_min_5b8db5042e.jpg",
    image2: "uploads/Screenshot_2024_04_30_113732_min_5126c268d8.png",
    whyUsList: ["stateExperience", "bestRate", "googleReviews"],
    dscrCalculation: {
      "Credit score": 680,
      "Purchase price": 140000,
      "Monthly rent": 1300,
      "Annual taxes": 1000,
      "Annual insurance": 800,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 105000, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Alabama: {
    image1: "uploads/DSCR_Loan_Montgomery_Alabama_da9ee4c84d.jpg",
    image2: "uploads/nh_2_fc1cf2f1bc.jpg",
    whyUsList: ["lowFees", "appraisalControl", "stateExperience"],
    dscrCalculation: {
      "Credit score": 689,
      "Purchase price": 119000,
      "Monthly rent": 1450,
      "Annual taxes": 700,
      "Annual insurance": 1100,
      "Annual HOA": 100,
      "Loan to value (LTV)": 75, // 75% LTV
      "Loan amount": 89250, // LTV * Purchase price
      "Interest rate": 7.5, // 7.5% interest rate
      "Loan purpose": "Purchase", // Loan purpose
    },
  },
  Houston: {
    image1: "uploads/DSCR_Loan_Houston_Header_Image_d01fd10deb.jpg",
    image2: "uploads/Houston_DSCR_Loan_Deal_Review_c1b4004f53.png",
    whyUsList: ["lowFees", "appraisalControl", "stateExperience"],
    dscrCalculation: {
      "Credit score": 720,
      "Purchase price": 221000, // Reduced by 15% from 260000
      "Monthly rent": 2145, // Increased by 10% from 1950
      "Annual taxes": 663, // 0.3% of purchase price
      "Annual insurance": 1600,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75,
      "Loan amount": 165750, // 75% of new purchase price
      "Interest rate": 6.37,
      "Title fees": 800, // Based on purchase price
      "Prepaid interest": 200,
      "Prepaid insurance": 400,
      "Loan purpose": "Purchase",
    },
  },
  Akron: {
    image1: "uploads/DSCR_Loan_Akron_Header_1aed14fd48.jpg",
    image2: "uploads/DSCR_Loan_Akron_Deal_Review_29010d2c05.png",
    whyUsList: ["lowFees", "appraisalControl", "stateExperience"],
    dscrCalculation: {
      "Credit score": 720,
      "Purchase price": 106250, // Reduced by 15% from 125000
      "Monthly rent": 1760, // Increased by 10% from 1600
      "Annual taxes": 319, // 0.3% of purchase price
      "Annual insurance": 1500,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75,
      "Loan amount": 79688, // 75% of new purchase price
      "Interest rate": 6.37,
      "Title fees": 500, // Based on purchase price
      "Prepaid interest": 200,
      "Prepaid insurance": 300,
      "Loan purpose": "Purchase",
    },
  },
  Indianapolis: {
    image1: "uploads/DSCR_Loan_Indianapolis_Header_493c33f163.jpg",
    image2: "uploads/DSCR_loan_Indianapolis_deal_review_4a3c2f895b.png",
    whyUsList: ["lowFees", "appraisalControl", "stateExperience"],
    dscrCalculation: {
      "Credit score": 720,
      "Purchase price": 212500, // Reduced by 15% from 250000
      "Monthly rent": 3080, // Increased by 10% from 2800
      "Annual taxes": 638, // 0.3% of purchase price
      "Annual insurance": 1700,
      "Annual HOA": 0,
      "Loan to value (LTV)": 75,
      "Loan amount": 159375, // 75% of new purchase price
      "Interest rate": 6.37,
      "Title fees": 700, // Based on purchase price
      "Prepaid interest": 200,
      "Prepaid insurance": 500,
      "Loan purpose": "Purchase",
    },
  },
  stateExperience: (dscrLoanState, attorneyState) => {
    return `${dscrLoanState} is an ${
      attorneyState ? "attorney state" : "title company state"
    }. Our extensive experience working with ${
      attorneyState ? "attorneys" : "title companies"
    } will ensure a <b>smooth closing</b>.`;
  },
  appraisalControl: (dscrLoanState, attorneyState) => {
    return `You will receive a <b>high quality appraisal</b> because our team will handle all aspects of the process. From ordering to disputing any inconsistencies. Our team is on your team.`;
  },
  lowFees: (dscrLoanState, attorneyState) => {
    return `We run an optimized business, ensuring that we charge only <b>bare minumum fees</b> to keep your deals as profitable as possible.`;
  },
  bestRate: (dscrLoanState, attorneyState) => {
    return `We never add an interest rate spread so you will always get our <b> best interest rate</b>. Everytime.`;
  },
  fastClose: (dscrLoanState, attorneyState) => {
    return `Our online document collection, appraisal process, dedicated loan team, extensive state specific experience are just some of the factors that ensure a <b>fast close</b>`;
  },
  onlineProcessing: (dscrLoanState, attorneyState) => {
    return `Our online system will list all the necessary documents, on day one, helping with you with a <b> streamlined closing </b>`;
  },
  experiencedInvestorsChooseUs: (dscrLoanState, attorneyState) => {
    return `Experience real estate investors in ${dscrLoanState} choose us time after time because we become their go-to lender because of our <b> high client service standards</b>`;
  },
  dedicatedClosingTeam: (dscrLoanState, attorneyState) => {
    return `Your Loan File will be processed by a <b>dedicated team</b>, not just one loan officer, which always ensures a smooth closing`;
  },
  googleReviews: (dscrLoanState, attorneyState) => {
    return `Our clients have nothing but good thing to say about us. See for yourself. <a href="https://www.google.com/search?q=google+reviews+offermarket&sca_esv=4771c1dce5b9df5f&sca_upv=1&source=hp&ei=6FRCZrDMG4TmkPIPkdy-6Ac&iflsig=AL9hbdgAAAAAZkJi-LTsqA6elVopP2a_-SrqLWoNiCgN&ved=0ahUKEwiw4N-gmouGAxUEM0QIHRGuD30Q4dUDCBc&uact=5&oq=google+reviews+offermarket&gs_lp=Egdnd3Mtd2l6Ihpnb29nbGUgcmV2aWV3cyBvZmZlcm1hcmtldDIFECEYoAEyBRAhGKABMgUQIRigAUiHIFAAWIUfcAB4AJABAJgBggGgAfIPqgEEMjMuM7gBA8gBAPgBAZgCGqACgxHCAgsQABiABBixAxiDAcICERAuGIAEGLEDGNEDGIMBGMcBwgIIEAAYgAQYsQPCAgUQABiABMICCxAuGIAEGMcBGK8BwgIOEC4YgAQYxwEYjgUYrwHCAgcQABiABBgKwgIGEAAYFhgewgILEAAYgAQYhgMYigXCAggQABiABBiiBMICCBAAGBYYHhgPmAMAkgcEMjIuNKAHnKEB&sclient=gws-wiz#lrd=0x89b7dfa5dd806c9b:0x9da546cdfa9772d1,1,,,,">Our reviews speak for themselves.</a>`;
  },
  attorneyStates: [
    "Alabama",
    "Connecticut",
    "Delaware",
    "Georgia",
    "Kentucky",
    "Louisiana",
    "Illinois",
    "Massachusetts",
    "Mississippi",
    "New Hampshire",
    "New York",
    "New Jersey",
    "North Carolina",
    "North Dakota",
    "South Dakota",
    "Oklahoma",
    "Ohio",
    "Rhode Island",
    "South Carolina",
    "Vermont",
    "West Virginia",
    "Wyoming",
  ],
};

export default dscrLoanStateData;
